<!--
 * @Author: zl
 * @Date: 2021-09-01 09:12:59
 * @LastEditTime: 2022-11-25 11:48:20
 * @LastEditors: Please set LastEditors
 * @Description: 用户详情查看
-->
<template>
	<div class="user-details-layout h100" v-loading="mainLoading">
		<el-row class="h100">
			<el-col :span="4" class="h100 left">
				<el-col :span="24" class="mb30">
					<div class="img-box sp-box">
						<i class="el-icon-search icons" v-if="baseForm.logoUrl" @click="doView('avatars')"></i>
						<img v-if="baseForm.logoUrl" :src="uploadUrl + baseForm.logoUrl" alt="" />
						<img v-else class="sp-img" src="@/assets/images/no-avatar.jpg" alt="" />
					</div>
					<p>个人头像</p>
				</el-col>
				<el-col :span="24" class="mb30" v-if="baseForm && baseForm.cardType == '1002048001'">
					<div class="img-box">
						<i class="el-icon-search icons" @click="doView('cardPic1')"></i>
						<img v-if="baseForm.cardPic1" :src="uploadUrl + baseForm.cardPic1" alt="" />
						<div v-else>身份证（头像面）</div>
					</div>
					<p>个人证件</p>
				</el-col>
				<el-col :span="24" class="mb30" v-if="baseForm && baseForm.cardType == '1002048001'">
					<div class="img-box">
						<i class="el-icon-search icons" @click="doView('cardPic2')"></i>
						<img v-if="baseForm.cardPic2" :src="uploadUrl + baseForm.cardPic2" alt="" />
						<div v-else>身份证（国徽面）</div>
					</div>
					<p>个人证件</p>
				</el-col>
				<template v-if="baseForm.otherFiles">
					<el-col :span="24" class="mb30" v-if="baseForm && baseForm.cardType != '1002048001'">
						<div
							class="img-box"
							v-for="(item, index) in baseForm.otherFiles"
							:class="{
								mb30: baseForm.otherFiles.length >= 2,
								mb10: baseForm.otherFiles.length == index + 1
							}"
							:key="'card' + index"
						>
							<i class="el-icon-search icons" @click="doView('idcard_3', index)"></i>
							<img :src="uploadUrl + item" alt="" />
						</div>
						<p>其它证件</p>
					</el-col>
				</template>
				<template v-else>
					<el-col :span="24" class="mb30" v-if="baseForm && baseForm.cardType != '1002048001'">
						<div class="img-box">
							<div>无</div>
						</div>
						<p>其它证件</p>
					</el-col>
				</template>
				<el-col :span="24" class="font12"> 附件：<span class="agreement" @click="readAgreement">注册协议</span> </el-col>
			</el-col>
			<el-col :span="20" class="flex-layout h100">
				<el-col :span="24" class="text-style top">
					<el-row>
						<el-col :span="12">
							<span>登录账户：</span>
							{{ baseForm.nickName }}
						</el-col>
						<el-col :span="12">
							<span>登录密码：</span>
							********
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<span>手机号：</span>
							{{ baseForm.phone }}
							<el-popover placement="bottom-start" width="480" trigger="click" @show="getPhoneChanges">
								<el-table :data="phoneChangeList" border size="mini" max-height="240">
									<el-table-column prop="oriContent" label="变更前" min-width="120" align="center" show-overflow-tooltip></el-table-column>
									<el-table-column prop="newContent" label="变更后" min-width="120" align="center" show-overflow-tooltip></el-table-column>
									<el-table-column prop="createDate" label="变更时间" min-width="160" align="center" show-overflow-tooltip></el-table-column>
								</el-table>
								<span slot="reference" class="phone-change-btn" title="变更记录">
									变更记录
									<svg-icon icon-class="changeRecord" class="phone-change-icon"></svg-icon>
								</span>
							</el-popover>
						</el-col>
						<el-col :span="12">
							<span>邮 箱：</span>
							{{ baseForm.email }}
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<span>昵 称：</span>
							{{ baseForm.nickName }}
						</el-col>
						<el-col :span="12">
							<span>账户状态：</span>
							{{ baseForm.isFlag ? '启用' : '禁用' }}
						</el-col>
					</el-row>
					<el-col :span="23" class="mt10">
						<div class="service-box">
							<span>申请开通的服务：</span>
							<div class="ahCenter">
								<el-tooltip effect="light" :content="this.rowData.isReal == 1 ? '已实名认证' : '未实名认证'" placement="top">
									<svg-icon
										icon-class="name-rz"
										class="icon spDiv"
										:class="{ blue: this.rowData.isReal == 1 }"
										@click="iconClick('name')"
									></svg-icon>
								</el-tooltip>
								<el-tooltip effect="light" :content="this.isApprove == 1 ? '已申请专家' : '未申请专家'" placement="top">
									<svg-icon
										icon-class="zhuanjia-rz"
										class="icon spDiv"
										:class="{ green: this.isApprove == 1 }"
										@click="iconClick('zj')"
									></svg-icon>
								</el-tooltip>
								<!-- <el-tooltip effect="light"
											:content="this.certificateList.length >= 1 ? '已申请CA' : '未申请CA'"
											placement="top">
									<svg-icon icon-class="CA-rz"
											  class="icon sp-icon"
											  :class="{ 'purple': this.certificateList.length >= 1 }"
											  @click="iconClick('ca')"></svg-icon>
								</el-tooltip> -->
							</div>
						</div>
					</el-col>
				</el-col>
				<el-col :span="24" class="middle padding10">
					<el-tabs v-model="activeName" @tab-click="tabClick">
						<el-tab-pane v-for="(item, index) in tabArr" :key="index" :label="item.label" :name="item.name">
							<!-- 基本信息 -->
							<template v-if="activeName == 'baseInfo' && index === 0">
								<el-form
									ref="sysUserInfo"
									:model="sysUserInfo"
									label-width="120px"
									class="overflow-y border-bottom no-bottm-border text-style"
								>
									<el-col :span="12">
										<span>姓 名：</span>
										{{ baseForm.sname }}
									</el-col>
									<el-col :span="12">
										<span>身份证号码：</span>
										{{ baseForm.idCard }}
									</el-col>
									<el-col :span="12">
										<span>性 别：</span>
										{{ baseForm.sex ? '男' : '女' }}
									</el-col>
									<el-col :span="12">
										<span>民 族：</span>
										<!-- {{  sysUserInfo && sysUserInfo.nationName ? sysUserInfo.nationName : '' }} -->
										{{ baseForm.nation }}
									</el-col>
									<el-col :span="12">
										<span>出生日期：</span>
										<span v-if="baseForm.birthday">
											{{ baseForm.birthday.substr(0, 11) || '' }}
										</span>
									</el-col>
									<el-col :span="12">
										<span>年 龄：</span>
										{{ baseForm.age ? baseForm.age : '' }}
									</el-col>
									<el-col :span="12">
										<span>其它联系电话：</span>
										{{ baseForm.otherPhone ? baseForm.otherPhone : '' }}
									</el-col>
									<el-col :span="12">
										<span>Q Q：</span>
										{{ baseForm.qq ? baseForm.qq : '' }}
									</el-col>
									<el-col :span="12">
										<span>微信号：</span>
										{{ baseForm.wechat ? baseForm.wechat : '' }}
									</el-col>
									<el-col :span="12" class="flex">
										<span>所在地：</span>
										<div class="w70">
											<address-form v-model="location" showMode="view" :showDetail="false"></address-form>
										</div>
									</el-col>
									<el-col :span="23">
										<span>详细地址：</span>
										{{ baseForm.address ? baseForm.address : '' }}
									</el-col>
								</el-form>
							</template>

							<!-- 工作经验 -->
							<template v-if="activeName == 'jobInfo'">
								<div class="text-style overflow-y">
									<el-row
										class="border-bottom"
										:class="{
											'no-bottm-border': tabList.length == index + 1
										}"
										v-for="(item, index) in tabList"
										:key="item.id + 'work'"
									>
										<el-col :span="23">
											<span>时 间：</span>
											<span v-if="item.startDate && item.startDate != ''">
												{{ '开始时间 ' + item.startDate.substr(0, 11) }}
											</span>
											<span v-else></span>
											<span class="ml5 mr5" v-if="item.endDate && item.endDate != ''">到</span>
											<span v-if="item.endDate && item.endDate != ''">
												{{ '结束时间 ' + item.endDate.substr(0, 11) }}
											</span>
											<span v-else></span>
										</el-col>
										<el-col :span="12">
											<span>公 司：</span>
											{{ item.company }}
										</el-col>
										<el-col :span="12">
											<span>公司性质：</span>
											{{ item.typeName }}
										</el-col>
										<el-col :span="12">
											<span>职 能：</span>
											{{ item.functions }}
										</el-col>
										<el-col :span="12">
											<span>行 业：</span>
											{{ item.industry }}
										</el-col>
										<el-col :span="12">
											<span>职 位：</span>
											{{ item.postion }}
										</el-col>
										<el-col :span="12">
											<span>岗 位： </span>
											{{ item.post }}
										</el-col>
										<el-col :span="23">
											<span>工作描述：</span>
											{{ item.description }}
										</el-col>
										<el-col :span="23">
											<span>工作类型：</span>
											<span v-if="item.jobType !== null">
												{{ item.jobType ? '全职' : '兼职' }}
											</span>
											<span v-else></span>
										</el-col>
									</el-row>
								</div>
								<!-- <div v-else class="no-data">暂无数据</div> -->
							</template>

							<!-- 项目经验 -->
							<template v-if="activeName == 'projectInfo'">
								<div class="text-style overflow-y">
									<el-row
										class="border-bottom"
										:class="{
											'no-bottm-border': tabList.length == index + 1
										}"
										v-for="(item, index) in tabList"
										:key="item.id + 'project'"
									>
										<el-col :span="6">
											<div class="upload-item sp-item">
												<public-upload
													isViewMode
													height="120px"
													listType="picture-card"
													:viewFilesList="
														item.files ? item.files : []
													"
												></public-upload>
												<el-col :span="24" class="mb0 sp-text">
													<div class="top-item-text">项目图片</div>
												</el-col>
											</div>
										</el-col>
										<el-col :span="18">
											<el-col :span="12">
												<span>所属公司：</span>
												{{ item.company }}
											</el-col>
											<el-col :span="12">
												<span>时 间：</span>
												<span v-if="item.startTime && item.startTime != ''">
													{{ '开始时间 ' + item.startTime.substr(0, 11) }}
												</span>
												<span v-else></span>
												<span class="ml5 mr5" v-if="item.endTime && item.endTime != ''">到</span>
												<span v-if="item.endTime && item.endTime != ''">
													{{ '结束时间 ' + item.endTime.substr(0, 11) }}
												</span>
												<span v-else></span>
											</el-col>
											<el-col :span="12">
												<span>项 目：</span>
												{{ item.project }}
											</el-col>
											<el-col :span="12">
												<span>项目描述：</span>
												{{ item.projectDes }}
											</el-col>
											<el-col :span="12">
												<span>责任描述：</span>
												{{ item.dutyDes }}
											</el-col>
										</el-col>
									</el-row>
								</div>
								<!-- <div v-else class="no-data">暂无数据</div> -->
							</template>

							<!-- 学历 -->
							<template v-if="activeName == 'educationCer'">
								<div class="text-style overflow-y">
									<el-row
										class="border-bottom"
										:class="{
											'no-bottm-border': tabList.length == index + 1
										}"
										v-for="(item, index) in tabList"
										:key="item.id + 'educationObject'"
									>
										<el-col :span="6">
											<div class="upload-item sp-item">
												<public-upload
													isViewMode
													height="120px"
													listType="picture-card"
													:viewFilesList="
														item.files ? item.files.filter((x) => x.assortment === `education_assortment`) : []
													"
												></public-upload>
												<el-col :span="24" class="mb0 sp-text">
													<div class="top-item-text">学历证书</div>
												</el-col>
											</div>
											<div class="upload-item sp-item">
												<public-upload
													isViewMode
													height="120px"
													listType="picture-card"
													:viewFilesList="item.files ? item.files.filter((x) => x.assortment === `eduItem2${index}`) : []"
												></public-upload>
												<el-col :span="24" class="mb0 sp-text">
													<div class="top-item-text">学位证书</div>
												</el-col>
											</div>
										</el-col>
										<el-col :span="18">
											<el-col :span="12">
												<span>证书编号：</span>
												{{ item.certificateNo }}
											</el-col>
											<el-col :span="12">
												<span>学 历：</span>
												{{ item.educationName }}
											</el-col>
											<!-- <el-col :span="12">
												<span>学历性质：</span>
												{{ item.degreeNatureName }}
											</el-col> -->
											<el-col :span="12">
												<span>证书取得日期：</span>
												<span v-if="item.issueDate && item.issueDate != ''">
													{{ item.issueDate.substr(0, 11) }}
												</span>
											</el-col>
											<el-col :span="12">
												<span>毕业院校：</span>
												{{ item.academy }}
											</el-col>
											<el-col :span="12">
												<span>专 业：</span>
												{{ item.profession }}
											</el-col>
											<el-col :span="12">
												<span>学位名称：</span>
												{{ item.degreeNameStr }}
											</el-col>
											<el-col :span="12">
												<span>学位类型：</span>
												{{ item.degreeTypeName ? item.degreeTypeName : '' }}
											</el-col>
											<el-col :span="12">
												<span>学制（X年）：</span>
												{{ item.years }}
											</el-col>
											<el-col :span="12">
												<span>是否全日制：</span>
												{{ item.isFull ? '是' : '否' }}
											</el-col>
										</el-col>
									</el-row>
								</div>
								<!-- <div v-else class="no-data">暂无数据</div> -->
							</template>

							<!-- 职称 -->
							<template v-if="activeName == 'titleCer'">
								<div class="text-style overflow-y">
									<el-row
										class="border-bottom"
										:class="{
											'no-bottm-border': tabList.length == index + 1
										}"
										v-for="(item, index) in tabList"
										:key="item.id + 'practiceObject'"
									>
										<el-col :span="6">
											<div class="upload-item">
												<public-upload
													isViewMode
													height="120px"
													listType="picture-card"
													:viewFilesList="item.files"
												></public-upload>
												<el-col :span="24" class="mb0">
													<div class="top-item-text">职称证书</div>
												</el-col>
											</div>
										</el-col>
										<el-col :span="18">
											<el-col :span="12">
												<span>职称证书编号：</span>
												{{ item.certificateNo }}
											</el-col>
											<el-col :span="12">
												<span>职称证书名称：</span>
												{{ item.certificateName }}
											</el-col>
											<el-col :span="12">
												<span>职 称：</span>
												{{ item.gradeName }}
											</el-col>
											<el-col :span="12">
												<span>职称专业：</span>
												{{ item.qualifiedStr }}
											</el-col>
											<el-col :span="12">
												<span>评审时间：</span>
												<span v-if="item.inspectDate && item.inspectDate != ''">
													{{ item.inspectDate.substr(0, 11) }}
												</span>
											</el-col>
											<el-col :span="12">
												<span>评审单位：</span>
												{{ item.inspectUnit }}
											</el-col>
										</el-col>
									</el-row>
								</div>
								<!-- <div v-else class="no-data">暂无数据</div> -->
							</template>

							<!-- 职业资格 -->
							<template v-if="activeName == 'practiceCer'">
								<div class="text-style overflow-y">
									<el-row
										class="border-bottom"
										:class="{
											'no-bottm-border': tabList.length == index + 1
										}"
										v-for="(item, index) in tabList"
										:key="item.id + 'certificateObject'"
									>
										<el-col :span="6">
											<div class="upload-item">
												<public-upload
													isViewMode
													height="120px"
													listType="picture-card"
													:viewFilesList="item.files"
												></public-upload>
												<el-col :span="24" class="mb0">
													<div class="top-item-text">执业资格证书</div>
												</el-col>
											</div>
										</el-col>
										<el-col :span="18">
											<el-col :span="12">
												<span>证书编号：</span>
												{{ item.certificateNo }}
											</el-col>
											<el-col :span="12">
												<span>证书名称：</span>
												{{ item.sname }}
											</el-col>
											<el-col :span="12">
												<span>执业资格：</span>
												{{ item.typeName }}
											</el-col>
											<el-col :span="12">
												<span>登记专业：</span>
												{{ item.professionName }}
											</el-col>
											<el-col :span="12">
												<span>证书等级：</span>
												{{ item.gradeName }}
											</el-col>
											<el-col :span="12">
												<span>发证单位：</span>
												{{ item.issueUnit }}
											</el-col>
											<el-col :span="12">
												<span>获取时间：</span>
												<span v-if="item.issueDate && item.issueDate != ''">
													{{ item.issueDate.substr(0, 11) }}
												</span>
											</el-col>
										</el-col>
									</el-row>
								</div>
							</template>

							<!-- 其它 -->
							<template v-if="activeName == 'otherCer'">
								<div class="text-style overflow-y">
									<el-row
										class="border-bottom"
										:class="{
											'no-bottm-border': tabList.length == index + 1
										}"
										v-for="(item, index) in tabList"
										:key="item.id + 'otherObject'"
									>
										<el-col :span="6">
											<div class="upload-item">
												<public-upload
													isViewMode
													height="120px"
													listType="picture-card"
													:viewFilesList="item.files"
												></public-upload>
												<el-col :span="24" class="mb0">
													<div class="top-item-text">其它证书{{ index + 1 }}</div>
												</el-col>
											</div>
										</el-col>
										<el-col :span="18">
											<el-col :span="12">
												<span>证书编号：</span>
												{{ item.certificateNo }}
											</el-col>
											<el-col :span="12">
												<span>证书名称：</span>
												{{ item.certificateName }}
											</el-col>
											<el-col :span="12">
												<span>证书类型：</span>
												{{ item.certificateType }}
											</el-col>
											<el-col :span="12">
												<span>发证单位：</span>
												{{ item.issueUnit }}
											</el-col>
											<el-col :span="12">
												<span>发证日期：</span>
												<span v-if="item.issueDate && item.issueDate != ''">
													{{ item.issueDate.substr(0, 11) }}
												</span>
											</el-col>
											<el-col :span="12">
												<span>有效期至：</span>
												<span v-if="item.dueDate && item.dueDate != ''">
													{{ item.dueDate.substr(0, 11) }}
												</span>
											</el-col>
										</el-col>
									</el-row>
								</div>
								<!-- <div v-else class="no-data">暂无数据</div> -->
							</template>
						</el-tab-pane>
					</el-tabs>
				</el-col>
				<el-col :span="24" class="bottom padding10">
					<p>关联的企业</p>
					<vxe-table
						align="center"
						auto-resize
						border
						class="mt20"
						size="small"
						:data="associatedData"
						highlight-current-row
						highlight-hover-row
						show-overflow="tooltip"
						show-header-overflow="tooltip"
					>
						<vxe-table-column field="tenantName" title="企业名称" align="left" header-align="center"></vxe-table-column>
						<vxe-table-column field="flatTypeName" title="单位类型"> </vxe-table-column>
						<vxe-table-column field="creditCode" title="统一社会信用代码"></vxe-table-column>
						<vxe-table-column field="idAdmin" title="关联企业身份">
							<template #default="{ row }">
								<span v-if="row.idAdmin == 0">企业人员</span>
								<span v-else-if="row.idAdmin == 1">企业主</span>
								<span v-else-if="row.idAdmin == 2">企业管理员</span>
							</template>
						</vxe-table-column>
					</vxe-table>
				</el-col>
			</el-col>
		</el-row>

		<!-- 专家认证弹框 -->
		<el-dialog :visible.sync="showExp" width="800px" title="专家认证" top="10vh" :close-on-click-modal="false" center destroy-on-close>
			<div class="mb30 text-center">
				<div v-if="this.isApprove == 1">
					<img src="@/assets/images/pass.png" class="mb10" alt="" />
					<p class="fontWeightBold">已成功通过专家认证</p>
				</div>
				<div v-if="this.isApprove == 3">
					<img src="@/assets/images/checking.png" class="mb10" alt="" />
					<p class="fontWeightBold">专家认证审核中</p>
				</div>
			</div>
			<div class="mt20 ml20 mr20" style="line-height: 40px">
				<el-row>
					<el-col :span="8" class="lefts"> 姓名 </el-col>
					<el-col :span="16" class="right">
						{{ expInfo.sname }}
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="lefts"> 身份证证件号 </el-col>
					<el-col :span="16" class="right" style="min-height: 1px">
						{{ expInfo.idCard }}
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="lefts"> 手机号 </el-col>
					<el-col :span="16" class="right">
						{{ expInfo.phone }}
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="lefts"> 邮箱地址 </el-col>
					<el-col :span="16" class="right">
						{{ expInfo.email }}
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="lefts"> 职称 </el-col>
					<el-col :span="16" class="right">
						{{ expInfo.practiceName }}
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="lefts"> 执业资格 </el-col>
					<el-col :span="16" class="right">
						{{ expInfo.certificateName }}
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="lefts"> 从业年限 </el-col>
					<el-col :span="16" class="right"> {{ expInfo.proYears }}年 </el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="lefts"> 发改委评标专业 </el-col>
					<el-col :span="16" class="right">
						{{ expInfo.majorFgw }}
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="lefts"> 财政部评标专业 </el-col>
					<el-col :span="16" class="right">
						{{ expInfo.majorCzb }}
					</el-col>
				</el-row>
			</div>
		</el-dialog>

		<!-- 查看实名认证信息 -->
		<el-dialog :visible.sync="showRealMsg" width="1000px" title="查看" top="10vh" :close-on-click-modal="false" center>
			<realName v-if="showRealMsg" :rowData="itemObj" form="user" ref="realNameView"></realName>
		</el-dialog>

		<!-- 协议内容 -->
		<el-dialog title="注册协议" :visible.sync="contentShow" :close-on-click-modal="false" center width="1000px">
			<div v-html="content"></div>
		</el-dialog>

		<!-- 图片预览 -->
		<el-dialog :visible.sync="previewShow" title="图片预览" append-to-body center>
			<img width="100%" :src="previewPath" alt="" />
		</el-dialog>
	</div>
</template>
<script>
import realName from '@/views/operation-management/audit-affairs-new/components/real-name'
import * as API from 'api/modules/registeredUser_new'
import { checkOtherRealNameInfo } from 'api/modules/audit'
import { getDealDetail } from 'api/modules/rulesManagement'
import { mapState } from 'vuex'
import VUE_CONFIG from '../../../../../vue.config.js'
import addressForm from '@/components/addressForm/addressForm'
export default {
	name: 'UserDetails',
	components: { realName, addressForm },
	props: {
		rowData: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			associatedData: [], //关联企业
			activeName: 'baseInfo',
			activeNames: '0',
			tabArr: [
				{ label: '基本信息', name: 'baseInfo' },
				{ label: '工作经验', name: 'jobInfo' },
				{ label: '项目经验', name: 'projectInfo' },
				{ label: '学历', name: 'educationCer' },
				{ label: '职称', name: 'titleCer' },
				{ label: '执业资格', name: 'practiceCer' },
				{ label: '其它', name: 'otherCer' }
			],
			baseForm: {}, //头部基本信息
			sysUserInfo: {}, //tab基础信息
			workExperienceObject: [], //tab 工作经验
			projectObject: [], //tab 项目经验
			educationObject: [], //tab 学历
			practiceObject: [], //tab 职称
			certificateObject: [], //tab 执业资格
			otherObject: [], //tab 其它
			showExp: false, // 专家认证信息弹窗显隐
			expInfo: {}, //专家信息
			showRealMsg: false, //实名认证弹窗显隐
			isApprove: '', //专家是否认证
			imgList: [],
			content: '', //协议内容
			contentShow: false,
			itemObj: {},
			otherFileList: [], // 其他证件实名认证附件
			mainLoading: true, //页面加载loading
			location: {
				province: {
					name: '',
					value: ''
				},
				city: {
					name: '',
					value: ''
				},
				area: {
					name: '',
					value: ''
				}
			},
			previewPath: '', //预览路径
			previewShow: false, //预览路径
			tabList: [],
			phoneChangeList: [] // 手机号变更记录
		}
	},
	created() {
		if (this.rowData && this.rowData.id) {
			this.getBaseInfo()
			// this.rowData.ralName == 1 && this.rowData.openId != ''
			// 	? this.getRealNameInfo()
			// 	: (this.itemObj.certificateType = this.rowData.cardType)
		} else {
			this.goBack()
		}
	},
	methods: {
		// 查询手机号变更记录
		getPhoneChanges() {
			API.getPhoneChanges({
				userId: this.rowData.id
			})
				.then((res) => {
					this.phoneChangeList = res.data || []
				})
				.catch(() => {
					this.phoneChangeList = []
				})
		},

		// 实名信息
		getRealNameInfo() {
			checkOtherRealNameInfo({
				isReal: this.rowData.status,
				createUserid: this.rowData.id,
				recordId: this.rowData.openId
			}).then((res) => {
				this.itemObj = res.data || {}
				this.itemObj.status = 1
				this.itemObj.id = this.rowData.openId
				this.itemObj.createUserid = this.rowData.id
			})
		},
		// 获取基本信息
		getBaseInfo() {
			this.imgList = []
			API.getUserDetails({
				userId: this.rowData.id
			})
				.then((res) => {
					this.mainLoading = false
					console.log(res.data)

					this.isApprove = res.data.baseInfo.expertFlag
					this.baseForm = res.data.baseInfo //基本信息
					this.associatedData = res.data.relateTes // 关联企业
				})
				.catch(() => {
					setTimeout(() => {
						this.mainLoading = false
					}, 500)
				})
		},

		//tab信息查询
		tabInfo(type) {
			API.getUserOthers({
				userId: this.rowData.id,
				type: type
			})
				.then((res) => {
					this.mainLoading = false
					console.log(res.data)
					this.tabList = res.data
				})
				.catch(() => {
					setTimeout(() => {
						this.mainLoading = false
					}, 500)
				})
		},

		// tab点击
		tabClick(e) {
			console.log(e._data.index)
			this.tabInfo(e._data.index)
			// this.getOtherMsg(data.index)
		},

		// icon 点击事件
		iconClick(type) {
			// switch (type) {
			// 	case 'name':
			// 		if (this.rowData.ralName == 1) {
			// 			this.showRealMsg = true
			// 			this.itemObj.status = 1
			// 			setTimeout(() => {
			// 				this.$refs.realNameView.setRealInfo(this.itemObj)
			// 			}, 200)
			// 		}
			// 		break
			// 	case 'zj':
			// 		if (this.isApprove == 1) {
			// 			this.showExp = true
			// 		}
			// 		break
			// }
		},

		// 阅读协议
		readAgreement() {
			getDealDetail({
				userId: this.baseForm.userId,
				dealId: '1560450079744917505'
			}).then((res) => {
				this.content = res.data
				// console.log(this.content)
				this.contentShow = true
			})
		},

		// 审查页返回审计代办页
		goBack() {
			this.$router.push({ path: '/registered-user-new' })
		},

		// 处理单位类型
		dealFlatType(data) {
			let obj = this.projectDict.dwlx.find((x) => x.value == data)
			if (obj) {
				return obj.sname
			}
			return ''
		},

		// 查看
		doView(type, index) {
			// let obj = this.imgList.find((x) => x.assortment == type)
			let uploadUrl = ''
			// 本地环境代理后无法直接获取路径
			if (process.env.VUE_APP_UPLOAD_URL == '/uploadApi') {
				uploadUrl = VUE_CONFIG.devServer.proxy['/uploadApi'].target
			} else {
				uploadUrl = process.env.VUE_APP_UPLOAD_URL
			}
			switch (type) {
				case 'avatars':
					this.previewPath = uploadUrl + this.baseForm.logoUrl
					break
				case 'cardPic1':
					this.previewPath = uploadUrl + this.baseForm.cardPic1
					break
				case 'cardPic2':
					this.previewPath = uploadUrl + this.baseForm.cardPic2
					break
				default:
					this.previewPath = uploadUrl + this.baseForm.otherFiles[index]
					break
			}
			this.previewShow = true
		}
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict
		}),

		// 上传接口地址
		uploadUrl() {
			let _uploadUrl = ''
			if (process.env.VUE_APP_UPLOAD_URL == '/uploadApi') {
				_uploadUrl = VUE_CONFIG.devServer.proxy['/uploadApi'].target
			} else {
				_uploadUrl = process.env.VUE_APP_UPLOAD_URL
			}
			return _uploadUrl
		}
	}
}
</script>
<style lang="less" scoped>
.user-details-layout {
	background-color: #fff;
	height: 100%;
	overflow-y: auto;
	.left {
		width: 220px;
		padding: 10px;
		display: flex;
		text-align: center;
		align-items: center;
		flex-direction: column;
		.agreement {
			text-decoration: underline;
			color: #2671cc;
			cursor: pointer;
		}
		.sp-box {
			width: 120px !important;
			padding: 0px !important;
		}
		.sp-box:hover {
			.sp-img {
				cursor: default;
				filter: none !important;
			}
		}
		.img-box {
			border-radius: 5px;
			width: 180px;
			height: 120px;
			margin: 0 auto 10px auto;
			position: relative;
			border: 1px solid #c2dcfb;
			border-radius: 5px;
			img,
			div {
				width: 100%;
				height: 100%;
				border-radius: 5px;
			}

			div {
				line-height: 110px;
				font-size: 12px;
			}
			.icons {
				font-size: 20px;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				color: #fff;
				display: none;
				z-index: 9999;
				cursor: pointer;
			}
		}
		.img-box:hover {
			img {
				cursor: pointer;
				filter: blur(1px) contrast(0.5) brightness(0.8);
			}
			.icons {
				display: block;
			}
		}
		p {
			margin-bottom: 10px;
			font-size: 12px;
		}
	}
	.flex-layout {
		width: calc(~'100% - 230px');
		display: flex !important;
		flex-direction: column;
		padding: 10px;
		// overflow-y: auto;
		.el-col-24 {
			padding: 10px;
		}
		/deep/ .el-tabs__content {
			min-height: 300px !important;
		}
		/deep/ .el-form-item__label {
			color: #666;
		}
		/deep/ .el-form-item__content {
			color: #000;
		}
	}
	.text-style {
		font-size: 14px;
		color: #000;

		.el-col {
			margin-bottom: 10px;
		}
		span:first-of-type {
			color: #666;
		}
	}
	.top {
		border: 1px solid #c2dcfb;
		background: #fbfdff;
		padding: 20px !important;
		max-height: 165px !important;
		.el-row {
			margin-bottom: 10px;
		}
		.el-col-12 {
			margin-bottom: 0;
		}

		.phone-change-btn {
			display: inline-flex;
			align-items: center;
			margin-left: 8px;
			color: #409eff;
			cursor: pointer;
			font-size: 12px;
			vertical-align: middle;

			.phone-change-icon {
				width: 14px;
				height: 14px;
				margin-left: 4px;
				color: #409eff;
			}
		}
	}
	.top,
	.bottom {
		flex: 1;
	}
	.middle {
		flex: 2;
		margin-top: 15px;
	}
	.padding10 {
		padding: 10px 0 !important;
	}
	.purple {
		color: purple !important;
	}
	.green {
		color: #72aa2c !important;
	}
	.blue {
		color: #2671cc !important;
	}
	.icon {
		width: 20px;
		height: 20px;
		margin-left: 10px;
	}
	.service-box {
		display: flex;
		.spDiv {
			margin-right: 10px;
			width: 25px !important;
			height: 25px !important;
		}
		.sp-icon {
			width: 19px !important;
			height: 19px !important;
		}
		.icon {
			cursor: pointer;
			color: #eee;
		}
	}
	.el-form-item {
		margin-bottom: 0px !important;
	}
	.upload-item {
		max-width: 180px;
		width: 100%;
		height: 120px;
		/deep/ .single-upload-layout,
		/deep/ .upload-demo {
			height: 100%;
		}
		/deep/ .single-upload-layout {
			height: 100%;
		}
		/deep/ .upload-text {
			vertical-align: middle !important;
		}
		/deep/.el-upload-list__item {
			width: 100% !important;
			height: 120px !important;
		}
		/deep/.el-upload {
			width: 100% !important;
			height: 120px !important;
		}
		/deep/ .img-size {
			width: 100% !important;
			height: 120px !important;
		}
		/deep/ .el-upload__tip {
			display: none;
		}
	}
	.sp-item {
		position: relative;
		height: 170px !important;
	}
	.sp-text {
		position: absolute;
		bottom: 10px;
	}
	.top-item-text {
		font-size: 12px;
		margin-top: 10px;
		color: #666;
		text-align: center;
	}
}
.fontWeightBold {
	color: #202020;
	font-size: 16px;
	margin-left: 15px;
}
.success-icon {
	width: 80px;
	height: 80px;
	margin-bottom: 20px;
}
.head {
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.lefts {
	color: #999999;
	font-size: 12px;
	display: flex;
	align-items: center;

	.icons {
		width: 19px !important;
		height: 19px !important;
		margin-right: 15px;
	}
}
.right {
	color: #202020;
	font-weight: 600;
	text-align: right;
}
.isPass {
	position: absolute;
	right: 0;
	top: 100px;
	padding: 0 10px;
	color: #000;
	height: 35px;
	line-height: 35px;
}
.border-bottom {
	padding: 20px 0 0 0;
	border-bottom: 2px dotted #eee;
}
.no-bottm-border {
	border-bottom: none;
}
.font12 {
	font-size: 12px;
}
.w70 {
	width: 70% !important;
}
.no-data {
	display: flex;
	height: 300px;
	justify-content: center;
	align-items: center;
}
.mb30 {
	margin-bottom: 30px !important;
}
.mb10 {
	margin-bottom: 10px !important;
}
.mb0 {
	margin-bottom: 0px !important;
}
</style>
